
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import defensiveCopy from "@/util/defensive-copy";
import { TypographyPresetLabelAndId } from "@/types/typography";
import { getUniqueTypographyPresetId } from "@/lib/typography/typography";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { globalStore } from "@/store/store-accessor";

@Component({
  components: { TextInput }
})
export default class TypographyPresetLabelAndIdInput extends Vue {
  @Prop()
  value!: TypographyPresetLabelAndId;

  mounted() {
    if (!this.value?.id || !this.value?.label) {
      const presetNumber = globalStore.typographyPresets
        ? globalStore.typographyPresets.length
        : 1;
      this.emit({
        label: `Preset ${presetNumber}`,
        id: getUniqueTypographyPresetId()
      });
    }
  }

  updateLabel(label: string | null) {
    this.emit({ ...this.value, label: label ?? undefined });
  }

  emit(value: Partial<TypographyPresetLabelAndId> | undefined) {
    const newValue = defensiveCopy(value);

    const newPresetLabelAndId: TypographyPresetLabelAndId = {
      label: newValue?.label || "",
      id: newValue?.id || getUniqueTypographyPresetId()
    };

    this.$emit("input", newPresetLabelAndId);
  }
}
